import React from 'react'
import { Modal } from 'react-bootstrap'
import CariDoctorService from '../Service/cariDoctorService'
import SpesialisSevice from '../Service/spesialisService'
import CatalogForm from './catalogForm'
import alamatRService from '../Service/alamatRService'
import indexDoctor from './index'
import { config } from '../Config/config'
import Cari_Doctor from './index'
import Detail_Doctor from '../DetailDoctor/index'
import LamaPengalaman from '../Service/pengalamanDoctor'
import jadwalDoctor from '../Service/statusOnlineDoctor'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import FormInput from './formInput'
import Login from '../Login/login'
import AppointmentService from '../Service/appointmentService'
import ModalBerhasilSimpan from './modalBerhasilSimpan'
import ModalLoading from './modalLoading'
import ModalPenuh from './modalPenuh'
import ModalTidakAdaDokter from './modalTidakAdaDokter'




export default class formCari extends React.Component {
    DoctorModel = {
        _id: "",
        biodata_id: "",
        doctor_id: "",
        specialization: "",
        medical_facility_id: "",
        str: "",
        fullname: "",
        mobile_phone: "",
        image: "",
        image_path: "",
        create_by: "",
        create_on: "",
        modified_by: "",
        modified_on: "",
        deleted_by: "",
        deleted_on: "",
        is_delete: false
    }

    AppointmentModel = {
        // _id: "",
        customer_id: "",
        doctor_office_id: "",
        doctor_office_schedule_id: "",
        doctor_office_treatment_id: "",
        appointment_date: "",
        is_delete: false,
        biodata_id: localStorage.getItem(config.biodata_id),
        doctor_id: localStorage.getItem(config.cariIdDoctor),
        medical_facility_id: "",
        created_by: localStorage.getItem(config.userid),
        tanggal_datang: "",
        tanggal_datang2: "",
        day: "",
        faskes: "",
        jam: "",
        idOffice: "",

        // nama_dokter: "",
    }

    constructor() {
        super()
        this.state = {
            List: [],
            ListSpesialis: [],
            ListAlamat: [],
            ListCariDoctor: [],
            ListPengalaman: [],
            ListJadwal: [],
            ListDoctor: [],
            Model: this.DoctorModel,
            Model2: this.AppointmentModel,
            ShowModal: false,
            ShowModalJanji: false,
            errors: {},
            filter: {
                location: '',
                spes: '',
                nameDoc: '',
                tinMed: '',
                page: localStorage.getItem(config.page),
                pagesize: localStorage.getItem(config.pagesize)
                // page: "1",
                // pagesize:"2"
            },
            idDoctor: "",
            TotalPage: 0,
            currentPage: 1,
            status: [],
            keterangan: [],
            hasil: [],
            final: [],
            data: {
                id_doctor: localStorage.getItem(config.cariIdDoctor),
            },
            relasiList: [],
            listTreatment: [],
            faskesList: [],
            disabled: true,
            showModalLoad: false,
            showModalPenuh: false,
            showModalNoDokter: false,
            ShowModalBerhasilSimpan: false,

            coba: [],
            d: new Date(),

            jamApp: "",
            menitApp: "",
            dateApp: "",
            monthApp: "",
            yearApp: "",
            jamNow: "",
            menitNow: "",
            dateNow: "",
            monthNow: "",
            yearNow: "",
        }
    }



    //untuk manggil semua data yang ada di db
    loadList = async () => {
        // const respon = await CariDoctorService.getFilter(this.state.filter)
        var filter2 = JSON.parse(localStorage.getItem(config.filter))
        const coba = []
        // console.log(filter2)
        const respon = await CariDoctorService.getFilter(filter2)
        console.log(respon.result)
        const responSpesialis = await SpesialisSevice.getAll()
        const responAlamat = await alamatRService.getAll()
        const responLamaPengalaman = await LamaPengalaman.getAllPengalaman()
        const responJadwal = await jadwalDoctor.getAll()
        const responJumlahData = await CariDoctorService.getFilterData(filter2)

        let jumlahData = responJumlahData.result.length

        // console.log(responLamaPengalaman)

        // console.log(localStorage.getItem(config.filter))
        const resRelasi = await AppointmentService.getAllDataJanji({ "biodata_id": this.AppointmentModel.biodata_id })
        if (resRelasi.success) {
            this.setState({
                relasiList: resRelasi.result
            })
        }
        const resFaskes = await AppointmentService.getFaskes({ "doctor_id": this.AppointmentModel.doctor_id })
        console.log(resFaskes.result)
        if (resFaskes.success) {
            this.setState({
                faskesList: resFaskes.result
            })
        }




        if (respon.success) {
            if (jumlahData != 0) {
                let hitung = jumlahData
                this.setState({
                    ListDoctor: responJumlahData.result,
                    List: respon.result,
                    ListSpesialis: responSpesialis.result,
                    ListAlamat: responAlamat.result,
                    ListPengalaman: responLamaPengalaman.result,
                    ListJadwal: responJadwal.result,
                    ListCariDoctor: filter2,
                    TotalPage: Math.ceil(hitung / this.state.filter.pagesize),
                    status: coba
                })

            } else {
                let hitung = 0
                if (respon.result == 0) {
                    // this.setState({
                    alert("Data tidak ditemukan")
                    // })
                }
            }

        }
        console.log(this.state.ListJadwal)

        // {
        //     this.state.ListJadwal.map(data => {
        //         if (data.validHari == true && data.validJam == true) {
        //             this.setState({
        //                 isOnline: "Online"
        //             })
        //         }
        //     })
        // }
        // if (this.state.isOnline == "Online") {
        //     this.setState({
        //         dispOff: "none",
        //         dispOn: ""
        //     })
        // } else {
        //     this.setState({
        //         isOnline: "Offline",
        //         dispOff: "",
        //         dispOn: "none"
        //     })
        // }

        {
            this.state.ListJadwal.map(data => {
                if (data.validHari == true && data.validJam == true) {
                    this.state.status.push({
                        isOnline: "Online",
                        id_doctor: data._id
                    })
                }
                else {
                    this.state.status.push({
                        isOnline: "Offline",
                        id_doctor: data._id
                    })
                }
            })
        }
        // console.log(coba)
        var newHasil = []
        var idxHasil = 0

        for (let i = 0; i < this.state.status.length; i++) {
            if (this.state.status[i].isOnline == "Online") {
                this.state.keterangan.push({ dispOff: "none", dispOn: "", id_doctor: this.state.status[i].id_doctor, isOnline: this.state.status[i].isOnline })
            } else {
                this.state.keterangan.push({ dispOff: "", dispOn: "none", id_doctor: this.state.status[i].id_doctor, isOnline: this.state.status[i].isOnline })
            }
        }

        // console.log(this.state.keterangan)
        {
            this.state.keterangan.map(ket => {

                // newHasil=[]
                if (this.state.hasil.length != 0) {
                    if (ket.isOnline == "Online") {
                        if (newHasil[idxHasil].iddoctor == ket.id_doctor) {
                            newHasil.splice(idxHasil, 1)
                            newHasil.push({ dispOff: ket.dispOff, dispOn: ket.dispOn, iddoctor: ket.id_doctor, isOnline: ket.isOnline })
                            // idxHasil += 1
                            //         this.state.hasil.push({ dispOff: ket.dispOff, dispOn: ket.dispOn, iddoctor: ket.id_doctor, isOnline: ket.isOnline })
                            this.setState({
                                hasil: newHasil
                            })
                        }
                        if (newHasil[idxHasil].iddoctor != ket.id_doctor) {
                            // newHasil.splice(idxHasil, 1)
                            newHasil.push({ dispOff: ket.dispOff, dispOn: ket.dispOn, iddoctor: ket.id_doctor, isOnline: ket.isOnline })
                            idxHasil += 1
                            //         this.state.hasil.push({ dispOff: ket.dispOff, dispOn: ket.dispOn, iddoctor: ket.id_doctor, isOnline: ket.isOnline })
                            this.setState({
                                hasil: newHasil
                            })
                        }
                    }
                    else {
                        if (newHasil[idxHasil].iddoctor != ket.id_doctor) {
                            newHasil.push({ dispOff: ket.dispOff, dispOn: ket.dispOn, iddoctor: ket.id_doctor, isOnline: ket.isOnline })
                            idxHasil += 1
                            //         this.state.hasil.push({ dispOff: ket.dispOff, dispOn: ket.dispOn, iddoctor: ket.id_doctor, isOnline: ket.isOnline })
                            this.setState({
                                hasil: newHasil
                            })
                        }
                    }
                } else {
                    newHasil.push({ dispOff: ket.dispOff, dispOn: ket.dispOn, iddoctor: ket.id_doctor, isOnline: ket.isOnline })
                    this.setState({
                        hasil: newHasil
                    })
                    // this.state.hasil.push({ dispOff: ket.dispOff, dispOn: ket.dispOn, iddoctor: ket.id_doctor, isOnline: ket.isOnline, test: 'test' })
                    // console.log(this.state.hasil)
                }
            })
        }
        console.log(this.state.keterangan)
        console.log(this.state.hasil)
    }



    //pertama kali ditampilkan akan muncul loadlist
    componentDidMount() {
        this.loadList()
    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            ShowModal: false,
            ShowModalJanji: false,
            disabled: true,
            showModalLoad: false,
            showModalPenuh: false,
            showModalNoDokter: false,
            ShowModalBerhasilSimpan: false,
            errors: {},
        })
    }

    changePageHandler = (number) => {
        console.log(this.state.ListCariDoctor)
        this.setState({
            ListCariDoctor: {
                ...this.state.ListCariDoctor,
                ["page"]: number
            },
            currentPage: number
        }, () => this.loadList())
    }


    changePage = (direction) => {
        if (direction == 'back') {
            this.setState({
                currentPage: this.state.currentPage - 1
            });
            this.changePageHandler(this.state.currentPage - 1)
        } else if (direction == 'next') {
            this.setState({
                currentPage: this.state.currentPage + 1
            });
            this.changePageHandler(this.state.currentPage + 1)
        }
    }


    renderPagination() {
        let item = []
        {
            this.state.currentPage > 1 ?
                item.push(
                    <PaginationItem key={0}>
                        <PaginationLink onClick={() => this.changePage("back")}>
                            Back
                </PaginationLink>
                    </PaginationItem>
                ) : null
        }
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        {
            this.state.currentPage < this.state.TotalPage ?
                item.push(
                    <PaginationItem>
                        <PaginationLink onClick={() => this.changePage("next")}>
                            Next
                </PaginationLink>
                    </PaginationItem>
                ) : null
        }
        return (
            <Pagination>
                {item}
            </Pagination>
        )
    }

    filterHandler = field => ({ target: { value } }) => {
        //setState untuk mengupdate
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    showModalDoctor = () => {
        this.setState({
            showModalDoctor: true
        })
    }

    cancelModal = () => {
        this.setState({
            showModalCari: false,
            showModalDoctor: false,
            errors: {},
        })
    }

    detailDoctor = (id) => {
        this.setState({
            idDoctor: id
        }, () => {
            localStorage.setItem(config.cariIdDoctor, this.state.idDoctor)
        })
        window.location.href = "/detail_dokter"
        console.log(localStorage.getItem(config.cariIdDoctor))
        // localStorage.setItem(config.cariIdDoctor, this.state.idDoctor)

    }

    // janjiHandler = () => {
    //     // this.setState({
    //     //     Mode: "Buat Janji",
    //     //     Model: this.AppointmentModel,
    //     //     // faskes: namaRS,                
    //     //     ShowModalJanji: true,

    //     // })

    //     if (!localStorage.getItem(config.token)) {
    //         this.setState({
    //             ShowModal: true
    //         })
    //     } else {
    //         this.setState({
    //             Mode: "Buat Janji",
    //             Model: this.AppointmentModel,
    //             ShowModalJanji: true,
    //         })
    //     }
    //     // console.log(this.state.ShowModal)
    // }

    janjiHandler = (id) => {
        this.setState({
            faskes: id,
            Model2: {
                ...this.state.Model2,
                doctor_office_id: id
            },

        },
            // () => this.loadList()
        )

        if (!localStorage.getItem(config.token)) {
            this.setState({
                ShowModal: true
            })
        } else {
            this.setState({
                Mode: "Buat Janji",
                Model2: this.AppointmentModel,
                ShowModalJanji: true,
                showModalNoDokter: false,
                showModalPenuh: false,
                idDoctor: id
            },
                () => { localStorage.setItem(config.cariIdDoctor, this.state.idDoctor) }
            )
        }
        console.log(this.state.idDoctor)
    }

    faskesHandler = async () => {
        const responListTreat = await AppointmentService.getTreatmentByDoctorOfficeId(this.state.Model2.doctor_office_id)
        console.log(responListTreat.result)
        console.log(this.state.Model2.doctor_office_id)
        // alert("TEST faskeshandler")


        if (responListTreat.success) {
            this.setState({
                listTreatment: responListTreat.result,
            })
        }
    }

    changeHandler2 = field => ({ target: { value } }) => {
        if (this.state.Model2.customer_id.length != 0) {
            this.setState({
                disabled: false,
            })
        }

        this.setState({
            Model2: {
                ...this.state.Model2,
                [field]: value
            },
            // disabled: false,
        },
            () => this.faskesHandler()
        )
        // console.log(this.state.Model.location_level_id)
        console.log(this.state.disabled)
    }

    // changeHandler = field => ({ target: { value } }) => {
    //     this.setState({
    //         Model2: {
    //             ...this.state.Model2,
    //             [field]: value
    //         },
    //         disabled: false,
    //     },
    //         () => this.faskesHandler()
    //     )        
    // }

    saveHandler = async () => {
        console.log(this.state.Mode)
        if (this.state.Mode == "Buat Janji") {
            if (this.handleValidation()) {
                // var d = new Date(this.state.Model.tanggal_datang)
                var d = new Date(this.state.Model2.appointment_date)
                var d1 = d.getDay().toString()
                this.setState({
                    showModalLoad: true,
                    tanggal: this.state.Model2.appointment_date.substring(0, 10),
                    jam: parseInt(this.state.Model2.appointment_date.substring(11, 13)),
                    Model2: {
                        ...this.state.Model2,
                        jam: parseInt(this.state.Model2.appointment_date.substring(11, 13)),
                        day: d.getDay().toString(),
                    }
                })
                console.log(this.state.Model2.appointment_date)
                console.log(this.state.Model2)

                var responDay = await AppointmentService.cekDayAppointment(
                    {
                        // "faskes": this.state.Model.medical_facility,
                        // "nama_dokter": this.state.Model.nama_dokter,
                        // "day": d1,
                        "day": d.getDay().toString(),
                        "jam": parseInt(this.state.Model2.appointment_date.substring(11, 13)),
                        // "jam": this.state.Model.jam,
                        "doctor_id": this.state.Model2.doctor_id,
                        "doctor_office_id": this.state.Model2.doctor_office_id,
                        // "doctor_office_id": this.state.idOffice,
                        "doctor_office_schedule_id": this.state.Model2.doctor_office_schedule_id,
                        "appointment_date": this.state.Model2.appointment_date,
                    })
                console.log(this.state.Model2)
                console.log(this.state.Model2.jam)
                console.log(responDay.result)

                // console.log(responDay.result[0].slot)
                // console.log(responDay.result[0].jam_end)
                // console.log(responDay.result[0].jam_start)
                // console.log(responDay.result.jam)

                // if (responDay.result.jam > responDay.result[0].jam_end) {
                //     alert("salah pilih jam")
                // }

                //jika hari dan jam sesuai jadwal dokter
                if (responDay.result.length != 0) {
                    console.log(responDay.result[0].slot)
                    console.log(responDay.result[0].jam_end)
                    console.log(responDay.result[0].jam_start)
                    this.setState({
                        slot: parseInt(responDay.result[0].slot),
                        Model2: {
                            ...this.state.Model2,
                            doctor_office_schedule_id: responDay.result[0].doctor_office_schedule_id,
                            jam: responDay.result.jam,

                        }
                    })
                    const responCek = await AppointmentService.cekRencanaAppoinment(this.state.tanggal)
                    this.setState({
                        cek: responCek.result,
                    })
                    console.log(this.state.cek)
                    console.log(this.state.Model2)
                    console.log(this.state.slot)
                    console.log(this.state.cek.length)
                    console.log(this.state.slot)


                    if (this.state.cek.length < this.state.slot) {
                        const respond = await AppointmentService.addDataJanji({
                            "_id": this.state.Model2._id,
                            "doctor_office_schedule_id": this.state.Model2.doctor_office_schedule_id,
                            "doctor_office_treatment_id": this.state.Model2.doctor_office_treatment_id,
                            "appointment_date": this.state.Model2.appointment_date,
                            "created_by": this.state.Model2.created_by,
                            "customer_id": this.state.Model2.customer_id,
                            "doctor_office_id": this.state.Model2.doctor_office_id,
                            // "doctor_office_id": this.state.idOffice,
                            // "day": d1,
                            // "jam": this.state.jam,
                            "day": d.getDay().toString(),
                            "jam": parseInt(this.state.Model2.appointment_date.substring(11, 13)),

                        })
                        console.log(respond)
                        console.log(this.state.cek.length)
                        console.log(this.state.slot)

                        this.setState({
                            Model2: respond.result,
                            jam: parseInt(this.state.Model2.tanggal_datang.substring(11, 13)),
                            tanggal_datang2: this.state.Model2.tanggal_datang.concat('Z'),

                        })
                        console.log(d1)
                        console.log(this.state.jam)
                        console.log(this.state.tanggal)
                        console.log(this.state.tanggal_datang2)

                        if (respond.success) {
                            // alert("Succes Save Data")
                            this.setState({
                                // Model: this.AppointmentModel,
                                ShowModalBerhasilSimpan: true,
                                ShowModalJanji: false,
                                showModalLoad: false,
                                showModalPenuh: false,
                                disabled: true,
                            }, () => { console.log(this.state.Model2) })

                            this.loadList()
                            // alert("Success Update Data")
                        }

                    } else {
                        this.setState({
                            showModal: false,
                            showModalLoad: false,
                            showModalPenuh: true
                        })
                    }

                }
                else {
                    this.setState({
                        showModalLoad: false,
                        showModalNoDokter: true
                    })
                }
            }
        } else {
            alert('Form has errors.')
        }
    }

    handleValidation() {
        let fields = this.state.Model2;
        let errors = {};
        let formIsValid = true;

        //get month and year NOW        
        var year = this.state.d.getFullYear()
        var yearStr = year.toString().substring(0, 4)
        var yearNow = parseInt(yearStr)
        var monthStr = this.state.d.getMonth().toString().substring(0, 2)
        var monthNow = parseInt(monthStr) + 1
        var dateNow = this.state.d.getDate().toString()
        var jamNow = parseInt(this.state.d.getHours().toString())
        var menitNow = parseInt(this.state.d.toString().substr(19, 2))



        //get month and year appoinment
        var day = new Date(this.state.Model2.appointment_date)
        var yearApp = parseInt(this.state.Model2.appointment_date.substring(0, 4))
        var monthApp = parseInt(this.state.Model2.appointment_date.substr(5, 2))
        var dateApp = this.state.Model2.appointment_date.substr(8, 2)
        var jamApp = parseInt(this.state.Model2.appointment_date.substring(11, 13))
        var menitApp = parseInt(this.state.Model2.appointment_date.substring(14, 16))

        console.log(this.state.d), console.log(this.state.d.getDate()), console.log(this.state.d.getHours())
        console.log(yearNow)
        console.log(monthNow)
        console.log(dateNow)
        console.log(jamNow)
        console.log(menitNow)

        console.log(this.state.Model2.appointment_date)
        console.log(yearApp)
        console.log(monthApp)
        console.log(dateApp)
        console.log(jamApp)
        console.log(menitApp)

        //Customer
        if (!fields["customer_id"]) {
            formIsValid = false;
            errors["customer"] = "* Pasien harus diisi."
        }

        //tanggal_janji
        // if (!fields["appointment_date"]) {
        //     formIsValid = false;
        //     errors["tanggal_janji"] = "* Tanggal dan Jam harus diisi."
        // }

        //tindakan
        if (!fields["doctor_office_treatment_id"]) {
            formIsValid = false;
            errors["tindakan"] = "* Tindakan harus diisi."
        }

        //tanggal_janji
        // if (!fields["tanggal_datang"]) {
        if (!fields["appointment_date"]) {
            formIsValid = false;
            // errors["tanggal_janji"] = "* Tanggal dan Jam harus diisi."
            errors["tanggal_janji_expired"] = "* Tanggal dan Jam harus diisi."
        } else if (fields["appointment_date"] != undefined) {
            if (yearNow == yearApp) {
                if (monthApp < monthNow) {
                    formIsValid = false;
                    errors["tanggal_janji_expired"] = "* Tanggal tidak valid."
                }
                else if (monthApp == monthNow) {
                    if (dateApp < dateNow) {
                        formIsValid = false;
                        errors["tanggal_janji_expired"] = "* Tanggal tidak valid."
                    }
                    else if (dateApp == dateNow) {
                        if (jamApp < jamNow) {
                            formIsValid = false;
                            errors["tanggal_janji_expired"] = "* Tanggal dan Jam tidak valid."
                        }
                        else if (jamApp == jamNow) {
                            if (menitApp < menitNow) {
                                formIsValid = false;
                                errors["tanggal_janji_expired"] = "* Tanggal dan Jam tidak valid."
                            }
                        }
                    }
                }

            }
            else if (yearApp < yearNow) {
                formIsValid = false
                errors["tanggal_janji_expired"] = "* Tanggal tidak valid."
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }




    render() {
        const { List, ListAlamat, idDoctor, ListCariDoctor, ListPengalaman, keterangan, final, hasil, status, id_doctor,
            ListJadwal, dispOff, dispOn, isOnline, ShowModalJanji, ShowModal, Model, Model2, listTreatment, errors } = this.state
        const { TampilanSearch } = this.props
        return (
            <div>
                {/* {JSON.stringify(ListJadwal)} */}
                {/* {JSON.stringify(listTreatment)} */}
                {/* {JSON.stringify(localStorage.getItem(config.hasilCariDoctor))} */}


                <table class="table" style={{ background: "white" }}>

                    {/* <thead>

                    </thead> */}

                    <tbody>
                        <div class="card-box">
                            {/* <div> */}
                            <div class="row">
                                <div class="col-sm-6 col-6">
                                    <h5 class="widget-user-desc">hasil pencarian berdasarkan kata kunci: {localStorage.getItem(config.hasilCariDoctor)}</h5>
                                </div>

                                <div class="col-sm-6 col-6 m-b-20 text-right">
                                    <button class="btn btn-white text-primary font-weight-bold" onClick={this.showModalDoctor}>Ulangi Pencarian</button>
                                </div>
                                {/* </div>
                            <div class="row"> */}
                                {
                                    //map untuk looping di dalam array
                                    List.map(data => {
                                        return (
                                            <CatalogForm
                                                data={data}
                                                ListAlamat={ListAlamat}
                                                ListPengalaman={ListPengalaman}
                                                ListJadwal={ListJadwal}
                                                detailDoctor={this.detailDoctor}
                                                dispOff={dispOff}
                                                dispOn={dispOn}
                                                isOnline={isOnline}
                                                janjiHandler={this.janjiHandler}
                                                ShowModalJanji={ShowModalJanji}
                                                cancelHandler={this.cancelHandler}
                                                ShowModal={ShowModal}
                                                relasiList={this.state.relasiList}
                                                faskesList={this.state.faskesList}
                                                listTreatment={this.state.listTreatment}
                                                changeHandler={this.changeHandler}
                                                changeHandler2={this.changeHandler2}
                                                Model={Model}
                                                Model={Model2}
                                                disabled={this.state.disabled}
                                                saveHandler={this.saveHandler}
                                                errors={errors}
                                                keterangan={keterangan}
                                                hasil={hasil}
                                                final={final}
                                                status={status}

                                            />

                                        )
                                    })
                                }
                            </div>
                        </div>
                    </tbody>

                </table>
                <div class="float-right">
                    {this.renderPagination()}
                </div>


                <Cari_Doctor
                    showModalDoctor={this.state.showModalDoctor}
                    cancelModal={this.cancelModal}
                />

                <FormInput
                    ShowModalJanji={ShowModalJanji}
                    janjiHandler={this.janjiHandler}
                    cancelHandler={this.cancelHandler}
                    List={List}
                    ListAlamat={ListAlamat}
                    ListPengalaman={ListPengalaman}
                    ListJadwal={ListJadwal}
                    detailDoctor={this.detailDoctor}
                    ShowModal={ShowModal}
                    relasiList={this.state.relasiList}
                    faskesList={this.state.faskesList}
                    listTreatment={this.state.listTreatment}
                    changeHandler={this.changeHandler}
                    changeHandler2={this.changeHandler2}
                    Model={Model}
                    Model={Model2}
                    disabled={this.state.disabled}
                    saveHandler={this.saveHandler}
                    errors={errors}
                />
                <ModalBerhasilSimpan
                    ShowModalBerhasilSimpan={this.state.ShowModalBerhasilSimpan}
                    cancelHandler={this.cancelHandler}
                    List={List}
                    Model={this.state.Model}
                    errors={errors}
                />
                <ModalLoading
                    showModalLoad={this.state.showModalLoad}
                    cancelHandler={this.cancelHandler}
                    List={List}
                    Model={this.state.Model}
                    errors={errors}
                />
                <ModalPenuh
                    showModalPenuh={this.state.showModalPenuh}
                    cancelHandler={this.cancelHandler}
                    List={List}
                    Model={this.state.Model}
                    Model2={this.state.Model2}
                    errors={errors}
                    janjiHandler={this.janjiHandler}
                    janjiHandler2={this.janjiHandler2}
                // data={data}
                // idOffice={idOffice}
                />
                <ModalTidakAdaDokter
                    showModalNoDokter={this.state.showModalNoDokter}
                    cancelHandler={this.cancelHandler}
                    janjiHandler={this.janjiHandler}
                    janjiHandler2={this.janjiHandler2}
                    saveHandler={this.saveHandler}
                    List={List}
                    Model={this.state.Model}
                    Model2={this.state.Model2}
                    errors={errors}
                // data={data}
                // idOffice={idOffice}
                />

                <Login
                    ShowModal={ShowModal}
                    cancelHandler={this.cancelHandler}
                // ModalRegHandler={this.ModalRegHandler}
                // ModalLupassHandler={this.ModalLupassHandler} 
                />
            </div >
        )
    }
}